import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { RequirementDataService } from "../../core/requirements.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-requirement",
    template: require('./requirement.edit.component.html')
})
export class EditRequirement extends EditBase<Nema.Crew.Model.CompetenceRequirement> {

    public checkAll: boolean = false;

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('requirement') requirementEntity: Nema.Crew.Model.CompetenceRequirement,
        @Inject("requirementSections") public requirementSections: Nema.Crew.Model.CompetenceRequirementCollection[],
        @Inject("authorities") public authorities: Nema.Crew.Model.Authority[],
        @Inject('competenceGroups') public competenceGroups: Nema.Crew.Model.CompetenceGroup[],
        @Inject("competenceTypes") public competenceTypes: Nema.Crew.Model.CompetenceType[],
        @Inject("activityTypes") public activityTypes: Nema.Crew.Model.ActivityType[],
        @Inject("roleTypes") public roleTypes: Nema.Crew.Model.RoleType[],
        @Inject(RequirementDataService.Id) private requirementDataService: RequirementDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, requirementEntity, requirementDataService, $log, isNew);

        if (!isNew) {
            (<any>this.entity.CompetenceRequirementActivityTypes).load();
            (<any>this.entity.CompetenceRequirementCompetenceTypes).load();
            (<any>this.entity.CompetenceRequirementRoleTypes).load();

            this.checkAll = this.entity.NrPersons == -1 ? true : false;
        }
    }

    public entityDisplayName = "Requirement";

    public listStateName = "app.settings.requirements";

    public onCheckboxChange(check: boolean): void {
        if (check) {
            this.checkAll = true;
            this.entity.NrPersons = -1;
        } else {
            this.checkAll = false;
            this.entity.NrPersons = 1;
        }
    }

    public addActivityType(): void {
        var newActivityType = this.requirementDataService.newRequirementActivityType(this.activityTypes[0].Id);
        this.entity.CompetenceRequirementActivityTypes.push(newActivityType);
    }

    public removeActivityType(actityType: Nema.Crew.Model.CompetenceRequirementActivityType): void {
        var index = this.entity.CompetenceRequirementActivityTypes.indexOf(actityType, 0);
        if (index > -1) {
            var mappingToDelete = this.entity.CompetenceRequirementActivityTypes[index];
            this.requirementDataService.removeMapping(mappingToDelete, () => this.entity.CompetenceRequirementActivityTypes.splice(index, 1));
        }
    }

    public addCompetence(): void {
        var newCompetence = this.requirementDataService.newRequirementCompetenceType(this.competenceTypes[0].Id);
        this.entity.CompetenceRequirementCompetenceTypes.push(newCompetence);
    }

    public removeCompetence(competence: Nema.Crew.Model.CompetenceRequirementCompetenceType): void {
        var index = this.entity.CompetenceRequirementCompetenceTypes.indexOf(competence, 0);
        if (index > -1) {
            var mappingToDelete = this.entity.CompetenceRequirementCompetenceTypes[index];
            this.requirementDataService.removeMapping(mappingToDelete, () => this.entity.CompetenceRequirementCompetenceTypes.splice(index, 1));
        }
    }

    public addRoleType(): void {
        var newRoleType = this.requirementDataService.newRequirementRoleType(this.roleTypes[0].Id);
        this.entity.CompetenceRequirementRoleTypes.push(newRoleType);
    }

    public removeRoleType(roleType: Nema.Crew.Model.CompetenceRequirementRoleType): void {
        var index = this.entity.CompetenceRequirementRoleTypes.indexOf(roleType, 0);
        if (index > -1) {
            var mappingToDelete = this.entity.CompetenceRequirementRoleTypes[index];
            this.requirementDataService.removeMapping(mappingToDelete, () => this.entity.CompetenceRequirementRoleTypes.splice(index, 1));
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirements/requirement.edit.component.ts